import React from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import config from '../../../../config/config';
import './QuantityStepper.css';

interface QuantityStepperProps {
  value: number;
  onChange: (value: number) => void;
  /** Upper bound, clamped to the API's own 999 ceiling. */
  max?: number;
  disabled?: boolean;
  size?: 'sm' | 'md';
  label?: string;
}

const QuantityStepper: React.FC<QuantityStepperProps> = ({
  value,
  onChange,
  max = config.shop.maxLineQty,
  disabled = false,
  size = 'md',
  label,
}) => {
  const { t } = useTranslation();
  const ceiling = Math.min(max, config.shop.maxLineQty);

  const commit = (next: number) => {
    if (!Number.isFinite(next)) return;
    onChange(Math.min(Math.max(Math.trunc(next), 1), ceiling));
  };

  return (
    <div className={`qty-stepper qty-stepper--${size}`}>
      <button
        type="button"
        onClick={() => commit(value - 1)}
        disabled={disabled || value <= 1}
        aria-label={t('shop.product.decreaseQty')}
      >
        <FaMinus aria-hidden="true" />
      </button>
      <input
        type="number"
        min={1}
        max={ceiling}
        value={value}
        disabled={disabled}
        aria-label={label ?? t('shop.product.quantity')}
        inputMode="numeric"
        onChange={(event) => {
          const parsed = Number(event.target.value);
          if (event.target.value === '') return;
          commit(parsed);
        }}
        onBlur={(event) => {
          if (event.target.value === '') commit(1);
        }}
      />
      <button
        type="button"
        onClick={() => commit(value + 1)}
        disabled={disabled || value >= ceiling}
        aria-label={t('shop.product.increaseQty')}
      >
        <FaPlus aria-hidden="true" />
      </button>
    </div>
  );
};

export default QuantityStepper;
